var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 4.5H6C5.60218 4.5 5.22064 4.65804 4.93934 4.93934C4.65804 5.22064 4.5 5.60218 4.5 6V36C4.5 36.3978 4.65804 36.7794 4.93934 37.0607C5.22064 37.342 5.60218 37.5 6 37.5H36C36.3978 37.5 36.7794 37.342 37.0607 37.0607C37.342 36.7794 37.5 36.3978 37.5 36V6C37.5 5.60218 37.342 5.22064 37.0607 4.93934C36.7794 4.65804 36.3978 4.5 36 4.5ZM6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6V36C0 37.5913 0.632141 39.1174 1.75736 40.2426C2.88258 41.3679 4.4087 42 6 42H36C37.5913 42 39.1174 41.3679 40.2426 40.2426C41.3679 39.1174 42 37.5913 42 36V6C42 4.4087 41.3679 2.88258 40.2426 1.75736C39.1174 0.632141 37.5913 0 36 0H6ZM33 29.571L25.5 21L18.072 29.49L13.5 24L9 29.4V33H33V29.571ZM16.5 21C17.6935 21 18.8381 20.5259 19.682 19.682C20.5259 18.8381 21 17.6935 21 16.5C21 15.3065 20.5259 14.1619 19.682 13.318C18.8381 12.4741 17.6935 12 16.5 12C15.3065 12 14.1619 12.4741 13.318 13.318C12.4741 14.1619 12 15.3065 12 16.5C12 17.6935 12.4741 18.8381 13.318 19.682C14.1619 20.5259 15.3065 21 16.5 21Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.58cefd4a2589e010bb9222f829428023.svg";
export { ForwardRef as ReactComponent };